import SiteLayout from '@/components/feature/SiteLayout'
import Hero from './components/Hero'
import AboutSection from '@/components/feature/sections/AboutSection'
import ServicesSection from '@/components/feature/sections/ServicesSection'
import PrintingSection from '@/components/feature/sections/PrintingSection'
import GallerySection from '@/components/feature/sections/GallerySection'
import WhyUsSection from '@/components/feature/sections/WhyUsSection'
import MarqueeBand from './components/MarqueeBand'
import ProcessSection from '@/components/feature/sections/ProcessSection'
import TestimonialsSection from '@/components/feature/sections/TestimonialsSection'
import FaqSection from '@/components/feature/sections/FaqSection'
import ContactSection from '@/components/feature/sections/ContactSection'

export default function Home() {
  return (
    <SiteLayout>
      <Hero />
      <AboutSection />
      <ServicesSection />
      <MarqueeBand />
      <PrintingSection />
      <GallerySection />
      <WhyUsSection />
      <ProcessSection />
      <TestimonialsSection />
      <FaqSection />
      <ContactSection />
    </SiteLayout>
  )
}